import { c as _c } from "react/compiler-runtime";
import { usePdfViewerInteractionContext } from "@/src/components/pdf-viewer/interaction-provider";
import { Label } from "@/src/components/shadcn/ui/label";
import { Select, SelectTrigger, SelectValue } from "@/src/components/shadcn/ui/select";
import { SelectWrapper } from "@/src/components/tasks/input-wrapper";
import { useServiceLines } from "@/src/lib/data-fetchers/service-lines-fetchers";
interface ServiceLineSelectorProps {
  value: string | undefined | null;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  isRequired?: boolean;
  onFlagForInaccuracyUpdate?: (key: string, value: any) => void;
  fieldKey?: string;
  metadata?: any;
  disabled?: boolean;
}
export default function ServiceLineSelector(t0) {
  const $ = _c(31);
  const {
    value,
    onChange,
    label: t1,
    placeholder,
    isRequired: t2,
    onFlagForInaccuracyUpdate,
    fieldKey: t3,
    metadata,
    disabled: t4
  } = t0;
  const label = t1 === undefined ? "Service Line" : t1;
  const isRequired = t2 === undefined ? false : t2;
  const fieldKey = t3 === undefined ? "serviceLine" : t3;
  const disabled = t4 === undefined ? false : t4;
  const {
    setMetadata,
    clearMetadata
  } = usePdfViewerInteractionContext();
  const {
    data: serviceLineOptions,
    isPending,
    isError,
    error
  } = useServiceLines();
  if (isPending) {
    let t5;
    if ($[0] !== label) {
      t5 = label && <div className="flex items-center justify-between"><Label className="text-muted-foreground">{label}</Label></div>;
      $[0] = label;
      $[1] = t5;
    } else {
      t5 = $[1];
    }
    let t6;
    if ($[2] !== t5) {
      t6 = <div className="mb-2">{t5}</div>;
      $[2] = t5;
      $[3] = t6;
    } else {
      t6 = $[3];
    }
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Select disabled={true}><SelectTrigger className="bg-input"><SelectValue placeholder="Loading service lines..." /></SelectTrigger></Select>;
      $[4] = t7;
    } else {
      t7 = $[4];
    }
    let t8;
    if ($[5] !== t6) {
      t8 = <div className="px-1">{t6}{t7}</div>;
      $[5] = t6;
      $[6] = t8;
    } else {
      t8 = $[6];
    }
    return t8;
  }
  if (isError || serviceLineOptions == null) {
    const errorMessage = error instanceof Error ? error.message : "Failed to fetch service lines";
    let t5;
    if ($[7] !== label) {
      t5 = label && <div className="text-muted-foreground">{label}</div>;
      $[7] = label;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t5) {
      t6 = <div className="mb-2">{t5}</div>;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== errorMessage) {
      t7 = <div className="bg-input px-3 py-2 rounded-md text-sm text-destructive">Error: {errorMessage}</div>;
      $[11] = errorMessage;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== t6 || $[14] !== t7) {
      t8 = <div className="px-1">{t6}{t7}</div>;
      $[13] = t6;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  let t5;
  if ($[16] !== metadata?.serviceLine_metadata || $[17] !== setMetadata) {
    t5 = () => setMetadata(metadata?.serviceLine_metadata);
    $[16] = metadata?.serviceLine_metadata;
    $[17] = setMetadata;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== clearMetadata || $[20] !== disabled || $[21] !== fieldKey || $[22] !== isRequired || $[23] !== label || $[24] !== onChange || $[25] !== onFlagForInaccuracyUpdate || $[26] !== placeholder || $[27] !== serviceLineOptions || $[28] !== t5 || $[29] !== value) {
    t6 = <SelectWrapper value={value} onChange={onChange} onFocus={t5} onBlur={clearMetadata} label={label} placeholder={placeholder} isRequired={isRequired} disabled={disabled} options={serviceLineOptions} onFlagForInaccuracyUpdate={onFlagForInaccuracyUpdate} fieldKey={fieldKey} />;
    $[19] = clearMetadata;
    $[20] = disabled;
    $[21] = fieldKey;
    $[22] = isRequired;
    $[23] = label;
    $[24] = onChange;
    $[25] = onFlagForInaccuracyUpdate;
    $[26] = placeholder;
    $[27] = serviceLineOptions;
    $[28] = t5;
    $[29] = value;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
}